import { useCart } from 'hooks/context/cart';
import { useGiftCardCart } from 'hooks/context/giftCardCart';
import { useRunningOrder } from 'hooks/context/RunningOrder';
import { LineItems, LineItemsProps } from './LineItems';

type CartLineItemsProps = Omit<LineItemsProps, 'items' | 'giftCardItems'>

export const CartLineItems: React.FC<CartLineItemsProps> = ({ ...props }) => {
  const { items } = useCart();
  const { items: giftCards } = useGiftCardCart();
  const runningOrder = useRunningOrder();

  return (<LineItems items={items} giftCardItems={giftCards} runningItems={runningOrder.items} {...props} />);
};
